<template>
  <div class="main-menubox d-flex mt-2">

  </div>
<!--  <div class="main-menubox d-flex mt-2">-->
<!--    <n-button-->
<!--        class="pl-0"-->
<!--        type="default"-->
<!--        link-->
<!--        @click="goMyGroup"-->

<!--        v-bind:class="{active:type==0}"-->
<!--    >-->
<!--&lt;!&ndash;    @click="onSubmit()"&ndash;&gt;-->


<!--    <span class="btb-link"><i class="el-icon-user-solid "></i>我的</span>-->
<!--    </n-button>-->
<!--    <n-button-->
<!--        type="default"-->
<!--        link-->
<!--        @click="$router.push('/group')"-->
<!--        v-bind:class="{active:type==2}"-->
<!--    >-->
<!--      <span>{{ $t('message').blog.menu_hot }}</span>-->
<!--    </n-button>-->

<!--  </div>-->
</template>
<script>
import {Button,} from '@/components';

export default {
  name: 'main-menu',
  props: {
    type: String,
  },
  components: {
    [Button.name]: Button,
  },
  methods: {
    goMyGroup() {
      this.$router.push('/group/discover')
    },
  }

};
</script>
<style scoped>
.main-menubox span {
  font-size: 1.125rem !important;
  font-weight: 500;
  margin-right: 1rem;
  color: #657786;
}

.main-menubox span:hover {
  color: black
}

.main-menubox button {
  margin: 0;
  margin-top: -5px;
}

.main-menubox .active span {
  color: black;
  font-weight: 600
}

.main-menubox .active {
  cursor: default !important;
}

textarea {
  border: #ddd 1px solid;
  border-radius: 5px
}

textarea:focus {
  border: 1px solid #8590a6;;
  outline: none
}
</style>
